import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';

import type { ILeiProfile } from '@core/models/app.model';
import { getCompanyNameFromLei } from '@helpers/get-compnay-name-from-lei';
import { PipeFunction } from '@shared/pipes/pipe-function.pipe';
import { CountryService } from '@shared/services/country.service';
import { UmeFlagComponent } from '@widgets/ume-flag/ume-flag.component';

import { LeiCompanyNamePipe } from '../../../routes/search/pipes/lei-company-name.pipe';

@Component({
  selector: 'ume-lei-details',
  templateUrl: './lei-details.component.html',
  styleUrls: ['./lei-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTabsModule,
    LeiCompanyNamePipe,
    PipeFunction,
    UmeFlagComponent,
  ],
})
export class LeiDetailsComponent {
  public countryService = inject(CountryService);

  @Input() leiProfile!: ILeiProfile;

  getOtherValidationAuthorities(
    value: ILeiProfile['attributes']['registration']['otherValidationAuthorities']
  ): string {
    return value.map((v) => v.validatedAs).join(', ');
  }

  getOtherEntityNames(value: ILeiProfile): string {
    const name = getCompanyNameFromLei(value);

    return [...value.attributes.entity.otherNames, value.attributes.entity.legalName]
      .filter((n) => n.name !== name)
      .map((v) => v.name)
      .join(', ');
  }

  getOtherTransliteratedNames(value: ILeiProfile): string {
    const name = getCompanyNameFromLei(value);

    return [...value.attributes.entity.transliteratedOtherNames]
      .filter((n) => n.name !== name)
      .map((v) => v.name)
      .join(', ');
  }
}
